export default __webpack_public_path__ + "static/media/floppy-disk.43f27b41.svg";